import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const CtaBand = () => (
  <section className="grain relative overflow-hidden bg-roch-navy py-20 sm:py-28">
    <div
      className="pointer-events-none absolute -left-32 top-0 h-[420px] w-[420px] rounded-full bg-roch-orange/15 blur-[110px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-end">
        <div>
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-roch-orange">Devis sous 48 h</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 max-w-xl font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">
              Votre toit mérite<br />
              <span className="text-roch-orange">LE ROCH.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <Link
            to="/devis"
            data-testid="cta-band-devis-button"
            className="group inline-flex items-center gap-3 rounded-full bg-roch-orange px-8 py-4 font-display text-base font-bold text-roch-navy transition-colors duration-300 hover:bg-roch-orangeHover"
          >
            Lancer mon estimation
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
